import {
  Coin,
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Flex,
  Icon,
} from '@customerio/pluma-components/react';

export function ExperimentsUnavailable() {
  return (
    <Flex alignItems="center" justifyContent="center" h="full" w="full" p="400">
      <EmptyState>
        <EmptyStateGraphic>
          <Coin size="lg" shape="rounded-square" colorVariant="grey">
            <Icon name="a-b-test" />
          </Coin>
        </EmptyStateGraphic>
        <EmptyStateTitle>Experiments are not available for this workspace</EmptyStateTitle>
        <EmptyStateDescription>Contact your account team to turn on A/B testing.</EmptyStateDescription>
      </EmptyState>
    </Flex>
  );
}
